// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2-14p","loadingContainer":"styles_loadingContainer__1SBO2","message":"styles_message__17kdV"};